(() => {
  const rootSelector = '#bundling-app';
  let syncQueued = false;

  const openNativeCart = async () => {
    const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    try {
      const response = await fetch(cartRoot + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error('Unable to refresh cart');

      const cart = await response.json();
      window.dispatchEvent(new CustomEvent('cartAPI', {
        detail: { cartData: cart }
      }));

      const openButton = document.querySelector('[data-native-cart-open]');
      if (openButton) openButton.click();
    } catch (error) {
      console.error('Native cart was not ready after the Recharge bundle was added.', error);
    }
  };

  window.RechargeBundle = window.RechargeBundle || {};
  window.RechargeBundle.onAddToCart = () => {
    window.setTimeout(() => openNativeCart(), 100);
  };

  const scheduleSync = () => {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(() => {
      syncQueued = false;
      syncSelectionTray();
    });
  };

  const scheduleAfterInteraction = () => {
    scheduleSync();
    window.setTimeout(scheduleSync, 80);
  };

  const createSelectionItem = ({ name, quantity, imageUrl }) => {
    const item = document.createElement('div');
    item.className = 'partake-bundle-selection__item';

    if (imageUrl) {
      const image = document.createElement('img');
      image.className = 'partake-bundle-selection__image';
      image.src = imageUrl;
      image.alt = '';
      image.loading = 'lazy';
      item.appendChild(image);
    }

    const copy = document.createElement('div');
    const title = document.createElement('span');
    title.className = 'partake-bundle-selection__name';
    title.textContent = name;

    const quantityLabel = document.createElement('span');
    quantityLabel.className = 'partake-bundle-selection__quantity';
    quantityLabel.textContent = 'Qty ' + quantity;

    copy.appendChild(title);
    copy.appendChild(quantityLabel);
    item.appendChild(copy);
    return item;
  };

  const syncSelectionTray = () => {
    const root = document.querySelector(rootSelector);
    const stickyContent = root && root.querySelector('.rb-sticky-content');
    if (!root || !stickyContent) return;

    let tray = stickyContent.querySelector('.partake-bundle-selection');
    if (!tray) {
      tray = document.createElement('div');
      tray.className = 'partake-bundle-selection';
      tray.setAttribute('role', 'status');
      tray.setAttribute('aria-live', 'polite');
      tray.setAttribute('aria-label', 'Your box selections');
      stickyContent.appendChild(tray);
    }

    const selected = Array.from(root.querySelectorAll('.rb-item')).map((item) => {
      const input = item.querySelector('.rb-input');
      const quantity = input ? parseInt(input.value, 10) || 0 : 0;
      const image = item.querySelector('.rb-item-img img');
      return {
        name: item.getAttribute('aria-label') || (input && input.getAttribute('aria-label')) || 'Selected product',
        quantity,
        imageUrl: image ? image.currentSrc || image.src : ''
      };
    }).filter((item) => item.quantity > 0);

    const signature = selected.map((item) => [item.name, item.quantity, item.imageUrl].join('|')).join('::');
    if (tray.dataset.signature === signature) return;
    tray.dataset.signature = signature;
    tray.replaceChildren();

    if (!selected.length) {
      const empty = document.createElement('p');
      empty.className = 'partake-bundle-selection__empty';
      empty.textContent = 'Your selections will appear here.';
      tray.appendChild(empty);
      return;
    }

    selected.forEach((item) => tray.appendChild(createSelectionItem(item)));
  };

  const initialize = () => {
    const root = document.querySelector(rootSelector);
    if (!root) {
      window.setTimeout(initialize, 250);
      return;
    }

    scheduleSync();
    root.addEventListener('click', scheduleAfterInteraction);
    root.addEventListener('change', scheduleAfterInteraction);
    root.addEventListener('input', scheduleAfterInteraction);

    const observer = new MutationObserver(scheduleSync);
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'disabled', 'aria-valuenow']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
